import { render } from "./FinancialResources.vue?vue&type=template&id=2629b9c4"
import script from "./FinancialResources.vue?vue&type=script&lang=js"
export * from "./FinancialResources.vue?vue&type=script&lang=js"

import "./FinancialResources.vue?vue&type=style&index=0&id=2629b9c4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__